import jQuery from "jquery";
import "bootstrap";
import Rails from "@rails/ujs";
import "@/tooltip";

try {
  Rails.start();
} catch (error) {
  // rails-ujs は、 es2015+ では Rails.start() を呼び出すことになっている。
  // この関数は多重起動のチェックを行っており、多重起動を検出した際に Error を発生させる。
  // ここでは、 rails-ujs の指示に従い呼び出しを行っている。
  // 一方で、モジュールの build 方法によって rails-ujs 内で自動で Rails.start() が実行される場合がある。
  // 現状では production 用に build すると、この状態になる。
  // rails-ujs の実装に対する依存を最小限に抑えながらこの問題を回避する為、発生する Error を catch し無視するようにした。
  // ただし、想定外の Error の発生を考慮し message をチェックしている。
  if (error.message !== "rails-ujs has already been loaded!") {
    console.error(error);
  }
}

window.jQuery = jQuery;
